import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export const StickyCTA = ({
  label = "Continue",
  onClick,
  disabled = false,
  helper,
  testId = "continue-button",
}) => {
  return (
    <div className="mt-8 md:mt-10 flex flex-col items-center gap-2">
      {helper && (
        <p className="text-xs md:text-sm text-zinc-500 dark:text-zinc-500 tracking-wide text-center">
          {helper}
        </p>
      )}
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        data-testid={testId}
        className={cn(
          "px-10 md:px-12 py-3.5 md:py-4 rounded-full font-semibold text-base md:text-lg",
          "flex items-center justify-center gap-2 transition-all duration-300",
          disabled
            ? "bg-zinc-200 text-zinc-400 cursor-not-allowed dark:bg-zinc-800 dark:text-zinc-500"
            : "bg-zinc-900 text-zinc-50 hover:bg-zinc-950 dark:bg-zinc-50 dark:text-zinc-950 dark:hover:bg-white hover:gap-3 active:scale-[0.98] shadow-[0_10px_40px_rgba(0,0,0,0.12)] dark:shadow-[0_10px_40px_rgba(255,255,255,0.12)]"
        )}
      >
        {label}
        <ArrowRight className="h-4 w-4 md:h-5 md:w-5" strokeWidth={2.5} />
      </button>
    </div>
  );
};
